import { ElementRef, Renderer2 } from '@angular/core';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormArray, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DestinationReceiverService } from '../destination-receiver.service';
import { ReporterService } from '../reporter.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import * as XLSX from '@e965/xlsx';

@Component({
    selector: 'app-trip-details',
    templateUrl: './trip-details.component.html',
    styleUrls: ['./trip-details.component.scss'],
    standalone: false
})
export class TripDetailsComponent implements OnInit, OnDestroy {
  documentId: any;
  otp: any;
  userId: any;
  tripData: any;
  submittedData:boolean = false;
  tripMaterialForm: any;
  date:any = new Date;
  showToolTip:boolean = false;
  showToolTipUnloadingTime:boolean = false;
  currentDate:any = new Date();
  supportedfiletype: Array<string> = ['pdf', 'png', 'jpg', 'jpeg', 'JPG', 'JPEG'];
  supportedvideotype: Array<string> = [
    'mp4', 'MP4', 
    'mov', 'MOV', 
    'avi', 'AVI', 
    'mkv', 'MKV', 
    'webm', 'WEBM',
    'm4v', 'M4V',  // iPhone/iPad video format
    '3gp', '3GP',  // Older mobile format
    'wmv', 'WMV',  // Windows format
    'flv', 'FLV',  // Flash format
    'f4v', 'F4V',  // Flash format
    'ogv', 'OGV',  // Ogg format
    'quicktime'    // iPhone MIME type
  ];
  isUploadingImage:boolean = false;
  isUploadingVideo:boolean = false;
  videoUploadProgress: number = 0;
  showVideoSuccess: boolean = false;
  errorMessage: String = '';
  formType: 'DROP_TYPE' | 'DESTINATION_TYPE' = 'DROP_TYPE';
  currentScreen: 'INPUT' | 'PREVIEW' = 'INPUT';
  showNoChangePopup:boolean = false;
  // OTP Modal properties
  showOTPModal: boolean = false;
  otpInput: string = '';
  otpBoxes: string[] = ['', '', '', '', '', ''];
  otpError: string = '';
  isOTPVerifying: boolean = false;
  private isProcessingOTPInput: boolean = false;
  isOTPVerificationEnabled: boolean = false;
  hasUnverifiedObservations: boolean = false;
  pendingUnloadingDetails: any = null;
  otpVerificationStatus: 'VERIFIED' | 'UNVERIFIED' = 'UNVERIFIED';
  // Resend OTP properties
  resendOtpFlag: boolean = false;
  otpInterval: any;
  remainingTime: string = '';
  canResendOTP: boolean = false;
  
  // Business hours properties
  isWithinBusinessHours: boolean = false;
  verificationDetails: any = null;
  // Historic Report Modal properties
  showHistoricReportModal: boolean = false;
  historicReportForm: any;
  dateRangeError: string = '';
  isDownloadingReport: boolean = false;
  downloadProgress: string = '';
  // Date/Time validation error
  unloadingTimeError: string = '';
  @ViewChild('customTip', { static: false }) menuStart: ElementRef;
  @ViewChild('customTipUnloadingDiv', { static: false }) timeUnloadingDiv: ElementRef;
  @ViewChild('multiDocFile', { static: false }) multiDocFile: ElementRef;
  @ViewChild('multiVideoFile', { static: false }) multiVideoFile: ElementRef;
  listenerFn: () => void;

  constructor( 
      private renderer: Renderer2,
      private route: ActivatedRoute, 
      public fb: UntypedFormBuilder, 
      private router: Router, 
      private reporterService: ReporterService,
      private destinationReceiverService: DestinationReceiverService,
      private _snackBar: MatSnackBar,
      private http: HttpClient,
    ) {
    this.listenerFn = this.renderer.listen('window', 'click', (e: Event) => {
        if (this.showToolTip && !this.menuStart.nativeElement.contains(e.target)) {
          this.showToolTip = false;
        }
        if (this.showToolTipUnloadingTime && !this.timeUnloadingDiv.nativeElement.contains(e.target)) {
          this.showToolTipUnloadingTime = false;
        }
    });
   }
  
  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.documentId = params.id;
      this.userId = params.phNo;
      this.otp = params.otp;
      this.formType = params.type;
    })
    const currentDate = new Date();
    let hours:any = currentDate.getHours();
    let minutes:any = currentDate.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    // Convert hours from 24-hour format to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // The hour '0' should be '12'
    hours = hours.toString().padStart(2, '0');
    minutes = minutes.toString().padStart(2, '0');
    let time = hours + ':' + minutes + ' ' + ampm;

    // Check business hours
    this.checkBusinessHours();
    
    // Set up timer to check business hours every minute
    setInterval(() => {
      this.checkBusinessHours();
    }, 60000); // Check every minute

    this.tripMaterialForm = this.fb.group({
      materialDispatchInfo: this.fb.array([]),
      'destReportedDate': ['', Validators.required],
      'destReportedTime': ['', Validators.required],
      'unloadingDate': [currentDate, Validators.required],
      'unloadingTime': [time, Validators.required],
      'repackagingCharges': ['', [Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
      'remarks': [''],
      'reporterDetails': [''],
      'qcDocs': [[]],
      'videoDocs': [[]],
    });
    
    // Initialize historic report form
    this.historicReportForm = this.fb.group({
      startDate: [null, Validators.required],
      endDate: [null, Validators.required]
    });
    
    this.checkUnloadingStatus();
  }

  checkUnloadingStatus() {
    let unloadingObservable: Observable<any>;
    if(this.formType == 'DROP_TYPE'){
      unloadingObservable = this.reporterService.checkUnloadingStatus(this.documentId);
    }else if(this.formType == 'DESTINATION_TYPE'){
      unloadingObservable = this.destinationReceiverService.checkUnloadingStatus(this.documentId);
    }
    unloadingObservable
    .subscribe(
      (data: any) => {
        if (data.id) {
          this.submittedData = true;
        } else {
          this.getTripDetails();
        }
      },
      (error: any) => { }
    );
  }

  reportedDateEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    this.tripMaterialForm.get('destReportedTime').reset();
    this.unloadingTimeError = ''; // Clear error when date changes
  }
  
  unloadedDateEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    this.tripMaterialForm.get('unloadingTime').reset();
    this.unloadingTimeError = ''; // Clear error when date changes
  }

  timePicked(event, type: 'REPORTED' | 'UNLOADING') {
    let hour = event.hour.toString().padStart(2, '0');
    let minute = event.minute.toString().padStart(2, '0');
    let zone = event.zone.toString().padStart(2, '0');
    let time = hour + ':' + minute + ' ' + zone;
    switch(type){
      case 'REPORTED':
        this.showToolTip = false;
        this.tripMaterialForm.get('destReportedTime').patchValue(time);
        // Validate unloading time if already set
        this.validateUnloadingAfterReporting();
        break;
      case 'UNLOADING':
        this.showToolTipUnloadingTime = false;
        this.tripMaterialForm.get('unloadingTime').patchValue(time);
        // Validate unloading time
        this.validateUnloadingAfterReporting();
        break;
    }
  }

  // Validate that unloading date/time is after reporting date/time
  validateUnloadingAfterReporting(): boolean {
    this.unloadingTimeError = '';
    
    const reportedDate = this.tripMaterialForm.get('destReportedDate')?.value;
    const reportedTime = this.tripMaterialForm.get('destReportedTime')?.value;
    const unloadingDate = this.tripMaterialForm.get('unloadingDate')?.value;
    const unloadingTime = this.tripMaterialForm.get('unloadingTime')?.value;
    
    // If any of the values are missing, skip validation
    if (!reportedDate || !reportedTime || !unloadingDate || !unloadingTime) {
      return true;
    }
    
    // Convert both to comparable datetime
    const reportedDateTime = this.convertToDateTime(reportedDate, reportedTime);
    const unloadingDateTime = this.convertToDateTime(unloadingDate, unloadingTime);
    
    if (!reportedDateTime || !unloadingDateTime) {
      return true;
    }
    
    if (unloadingDateTime < reportedDateTime) {
      this.unloadingTimeError = 'Unloading date/time must be after reporting date/time';
      return false;
    }
    
    return true;
  }

  // Helper method to convert date and time string to Date object
  private convertToDateTime(date: any, time: string): Date | null {
    if (!date || !time) return null;
    
    try {
      let dateObj: Date;
      if (date instanceof Date) {
        dateObj = new Date(date);
      } else if (date && typeof date === 'object' && date._d instanceof Date) {
        // Handle Moment objects
        dateObj = new Date(date._d);
      } else if (date && typeof date === 'object' && date._isAMomentObject && typeof date.toDate === 'function') {
        dateObj = date.toDate();
      } else {
        dateObj = new Date(date);
      }
      
      // Parse time string (format: "HH:MM AM/PM")
      const timeArray = time.split(/[ :]+/);
      if (timeArray.length < 3) return null;
      
      let hour = parseInt(timeArray[0], 10);
      const minute = parseInt(timeArray[1], 10);
      const zone = timeArray[2];
      
      // Convert to 24-hour format
      if (zone === 'PM' && hour !== 12) {
        hour += 12;
      } else if (zone === 'AM' && hour === 12) {
        hour = 0;
      }
      
      dateObj.setHours(hour, minute, 0, 0);
      return dateObj;
    } catch (e) {
      return null;
    }
  }

  convertDateTime(date, time) {
    let timeArray = time.split(/[ :]+/);
    let zone = timeArray[2];
    let minute = timeArray[1];
    let newDate = new Date(date);
    let day = newDate.getDate();
    let month = newDate.getMonth() + 1;
    let year = newDate.getFullYear();
    // convert to 24 hours
    let hour24 = timeArray[0];
    if (zone === 'PM') {
        if (hour24 !== "12") {
            hour24 = 12 + parseInt(hour24);
        }
    } else if (zone === 'AM') {
        if (hour24 === "12") {
            hour24 = 0;
        }
    }
    // "startTime": "2020-12-28T09:30:00+05:30"
    let convertedDate = year + '-' + ("0" + month).slice(-2)
        + '-' + ("0" + day).slice(-2) + 'T'
        + ("0" + hour24).slice(-2) + ':' + ("0" + minute).slice(-2)
        + ":00+05:30";

    return convertedDate;
}

  getTripDetails() {
    let payload = {
      "otp": this.otp
    }

    let confirmOtpObservable: Observable<any>;
    if(this.formType == 'DROP_TYPE'){
      confirmOtpObservable = this.reporterService.login(this.userId, payload);
    }else if(this.formType == 'DESTINATION_TYPE'){
      confirmOtpObservable = this.destinationReceiverService.login(this.userId, payload);
    }

    confirmOtpObservable
    .subscribe(
      (data: any) => {
        this.tripData = data;
        // Set OTP verification flags from trip data

        this.patchTripData();
      },
      (error: any) => {
        //
      }
    );
  }

  uploadFile(event) {
    const file = event.target.files[0];
    if (!file) {
      return;
    }

    let type = file.type;
    let size = file.size;
    const maxSizeBytes = 5 * 1024 * 1024; // 5 MB in bytes
    const maxSizeMB = 5;
    
    if (!this.supportedfiletype.includes(type.split('/')[1])) {
      this.errorMessage = 'Image format not supported. Supported formats: PDF, PNG, JPG, JPEG';
      this.multiDocFile.nativeElement.value = '';
      return;
    }
    
    if (size > maxSizeBytes) {
      const fileSizeMB = (size / (1024 * 1024)).toFixed(2);
      this.errorMessage = `Image file size (${fileSizeMB} MB) exceeds the maximum allowed size of ${maxSizeMB} MB. Please upload a smaller image file.`;
      this.multiDocFile.nativeElement.value = '';
      return;
    }
    
    this.errorMessage = '';
    this.isUploadingImage = true;
    this.reporterService.uploadfile(type, file, 300)
        .pipe(
          catchError((error: any) => {
            return throwError(error);
          }),
        )
        .subscribe(data => {
          const documentData = {
            "documentId": data.id,
            "documentKey": data.key,
            "documentName": file.name,
            "s3Url": data.s3Url,
            "fileMd5Hash": data.fileMd5Hash
          };
          this.tripMaterialForm.get('qcDocs').value.push(documentData);
          this.multiDocFile.nativeElement.value = '';
          this.isUploadingImage = false;
        });
  }

  uploadVideo(event) {
    const file = event.target.files[0];
    if (!file) {
      return;
    }

    let type = file.type;
    let size = file.size;
    const videoFormat = type.split('/')[1];
    const fileName = file.name.toLowerCase();
    const maxSizeBytes = 200 * 1024 * 1024; // 200 MB in bytes
    const maxSizeMB = 200;
    
    // Check if format is supported (either by MIME type or file extension)
    const isSupported = this.supportedvideotype.includes(videoFormat) || 
                       this.supportedvideotype.some(format => fileName.includes(format.toLowerCase()));
    
    if (!isSupported) {
      this.errorMessage = `Video format '${videoFormat}' not supported. Supported formats: MP4, MOV, AVI, MKV, WEBM, M4V, 3GP, WMV, FLV, F4V, OGV, QuickTime`;
      this.multiVideoFile.nativeElement.value = '';
      return;
    }
    
    if (size > maxSizeBytes) {
      const fileSizeMB = (size / (1024 * 1024)).toFixed(2);
      this.errorMessage = `Video file size (${fileSizeMB} MB) exceeds the maximum allowed size of ${maxSizeMB} MB. Please upload a smaller video file.`;
      this.multiVideoFile.nativeElement.value = '';
      return;
    }
    
    this.errorMessage = '';
    this.isUploadingVideo = true;
    this.videoUploadProgress = 0;
      
      // Simulate progress for better UX
      const progressInterval = setInterval(() => {
        if (this.videoUploadProgress < 90) {
          this.videoUploadProgress += Math.random() * 10;
        }
      }, 500);
      
      this.reporterService.uploadfile(type, file, 300)
        .pipe(
          catchError((error: any) => {
            clearInterval(progressInterval);
            this.isUploadingVideo = false;
            this.videoUploadProgress = 0;
            this.errorMessage = 'Video upload failed. Please try again.';
            return throwError(error);
          }),
        )
        .subscribe(data => {
          clearInterval(progressInterval);
          this.videoUploadProgress = 100;
          
          // Add a small delay to show 100% completion
          setTimeout(() => {
            const documentData = {
              "documentId": data.id,
              "documentKey": data.key,
              "documentName": file.name,
              "s3Url": data.s3Url,
              "fileMd5Hash": data.fileMd5Hash
            };
            this.tripMaterialForm.get('videoDocs').value.push(documentData);
            this.multiVideoFile.nativeElement.value = '';
            this.isUploadingVideo = false;
            this.videoUploadProgress = 0;
            
            // Show success message
            this.showVideoSuccess = true;
            setTimeout(() => {
              this.showVideoSuccess = false;
            }, 3000);
          }, 500);
        });
  }

  patchTripData() {
    let destinations;
    this.otpVerificationStatus = this.tripData.otpVerificationStatus || 'UNVERIFIED';
    this.isOTPVerificationEnabled = this.tripData.isOTPVerificationEnabled || false;
    this.hasUnverifiedObservations = this.tripData.hasUnverifiedObservations || false;

    if(this.hasUnverifiedObservations){
      const url = `${environment.conciergeUrl}/concierge/api/v1/driver/verify-observation/${this.tripData.accessCode}`;
    
      this.http.get(url).subscribe({
        next: (response: any) => {
          this.verificationDetails = response;
          console.log('Verification response:', response);
          
          // Patch form with verification details if present
          this.patchFormWithExistingData(response);
        },
        error: (error) => {
          console.error('Verification error:', error);
        }
      });
    }
    
    if(this.formType == 'DROP_TYPE'){
      destinations = this.tripData.dropPoint;
    }else if(this.formType == 'DESTINATION_TYPE'){
      destinations = this.tripData;
    }
    
    const materials = this.tripMaterialForm.get('materialDispatchInfo') as FormArray;
    destinations.materials.forEach((material: any) => {
      if(material.quantity && material.quantity > 0){
        let form = this.fb.group({
          id: [material.id],
          weight: material.weight ? [material.weight] : [],
          totalWeight: material.totalWeight ? [material.totalWeight] : [],
          material: material.material ? [material.material] : material.name ? [material.name] : [],
          sku: material.sku ? [material.sku] : [],
          quantity: [material.quantity],
          breakageQuantity: ['0', [Validators.pattern('[0-9]*')]],
          leakageQuantity: ['0', [Validators.pattern('[0-9]*')]],
          shortageQuantity: ['0', [Validators.pattern('[0-9]*')]],
          shippingUnit: [material.shippingUnit ? material.shippingUnit : material.qtyUnit]
        });
        materials.push(form);
      }
    });

  }

  resetBottelCan(material: any) {
    material.get('breakageQuantity').reset();
    material.get('shortageQuantity').reset();
    material.get('leakageQuantity').reset();
  }

  patchFormWithExistingData(data: any) {
    if (!data) return;

    console.log('Patching form with existing data:', data);

    // Patch basic form fields
    if (data.destReportedTime) {
      const reportedDate = new Date(data.destReportedTime);
      this.tripMaterialForm.patchValue({
        destReportedDate: reportedDate,
        destReportedTime: this.formatTimeFromDate(reportedDate)
      });
    }

    if (data.unloadingTime) {
      const unloadingDate = new Date(data.unloadingTime);
      this.tripMaterialForm.patchValue({
        unloadingDate: unloadingDate,
        unloadingTime: this.formatTimeFromDate(unloadingDate)
      });
    }

    if (data.repackagingCharges !== null && data.repackagingCharges !== undefined) {
      this.tripMaterialForm.patchValue({
        repackagingCharges: data.repackagingCharges
      });
    }

    if (data.remarks) {
      this.tripMaterialForm.patchValue({
        remarks: data.remarks
      });
    }

    if (data.recipientDetails) {
      this.tripMaterialForm.patchValue({
        reporterDetails: data.recipientDetails
      });
    }

    // Patch material details
    if (data.materialDetails && data.materialDetails.length > 0) {
      this.patchMaterialDetails(data.materialDetails);
    }

    // Patch observation documents
    if (data.observationDocuments && data.observationDocuments.length > 0) {
      this.patchObservationDocuments(data.observationDocuments);
    }
  }

  patchMaterialDetails(materialDetails: any[]) {
    const materialArray = this.tripMaterialForm.get('materialDispatchInfo') as FormArray;
    
    // Clear existing materials
    while (materialArray.length !== 0) {
      materialArray.removeAt(0);
    }

    // Add materials from data
    materialDetails.forEach(material => {
      const materialGroup = this.fb.group({
        id: [material.materialId || ''],
        material: [material.material || ''],
        quantity: [material.quantity || 0],
        shippingUnit: [material.shippingUnit || ''],
        sku: [material.sku || ''],
        breakageQuantity: [material.breakageQuantity || 0],
        shortageQuantity: [material.shortageQuantity || 0]
      });
      materialArray.push(materialGroup);
    });
  }

  patchObservationDocuments(documents: any[]) {
    const imageDocs = documents.filter(doc => 
      doc.documentName && this.isImageFile(doc.documentName)
    );
    const videoDocs = documents.filter(doc => 
      doc.documentName && this.isVideoFile(doc.documentName)
    );

    // Convert documents to the format expected by the form
    const formattedImageDocs = imageDocs.map(doc => ({
      documentId: doc.documentId,
      documentKey: doc.documentKey,
      documentName: doc.documentName,
      s3Url: doc.documentUrl
    }));

    const formattedVideoDocs = videoDocs.map(doc => ({
      documentId: doc.documentId,
      documentKey: doc.documentKey,
      documentName: doc.documentName,
      s3Url: doc.documentUrl
    }));

    this.tripMaterialForm.patchValue({
      qcDocs: formattedImageDocs,
      videoDocs: formattedVideoDocs
    });
  }

  formatTimeFromDate(date: Date): string {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    let displayHours = hours % 12;
    displayHours = displayHours ? displayHours : 12;
    const displayMinutes = minutes.toString().padStart(2, '0');
    return `${displayHours}:${displayMinutes} ${ampm}`;
  }

  isImageFile(filename: string): boolean {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
    const extension = filename.split('.').pop()?.toLowerCase();
    return imageExtensions.includes(extension || '');
  }

  isVideoFile(filename: string): boolean {
    const videoExtensions = ['mp4', 'mov', 'avi', 'mkv', 'webm', 'm4v', '3gp', 'wmv', 'flv', 'f4v', 'ogv'];
    const extension = filename.split('.').pop()?.toLowerCase();
    return videoExtensions.includes(extension || '');
  }

  toogleReviewScreens(){
    if(this.currentScreen == 'INPUT'){
      this.showNoChangePopup = true;
    }
    this.currentScreen = this.currentScreen == 'INPUT' ? 'PREVIEW' : 'INPUT';
  }



  checkValidity() {
    let disbaled = true;

    // Check if all mandatory date/time fields are filled
    const hasReportedDate = this.tripMaterialForm.value.destReportedDate;
    const hasReportedTime = this.tripMaterialForm.value.destReportedTime;
    const hasUnloadingDate = this.tripMaterialForm.value.unloadingDate;
    const hasUnloadingTime = this.tripMaterialForm.value.unloadingTime;

    if (hasReportedDate && hasReportedTime && hasUnloadingDate && hasUnloadingTime) {
      disbaled = false;
      this.tripMaterialForm.get('materialDispatchInfo').value.forEach((trip: any) => {
        if(trip.bottle || trip.cans){
          if(!trip.breakageQuantity && !trip.leakageQuantity && !trip.shortageQuantity ){
            disbaled = true;
          }
        }
       
      });
    }
    if(this.isUploadingImage || this.isUploadingVideo){
      disbaled = true;
    }
    // Check if there are any documents (images or videos)
    const totalDocuments = (this.tripMaterialForm.value.qcDocs?.length || 0) + (this.tripMaterialForm.value.videoDocs?.length || 0);
    if(totalDocuments == 0){
      disbaled = true;
    }
    
    // Validate that unloading time is after reporting time
    if (!this.validateUnloadingAfterReporting()) {
      disbaled = true;
    }

    return disbaled;
  }

  playVideo(video: any) {
    if (video.s3Url) {
      // Open video in a new tab for full-screen viewing
      window.open(video.s3Url, '_blank');
    }
  }

  downloadVideo(video: any) {
    if (video.s3Url) {
      // Create a temporary link to download the video
      const link = document.createElement('a');
      link.href = video.s3Url;
      link.download = video.documentName;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  viewImage(image: any) {
    if (image.s3Url) {
      // Open image in a new tab for full-screen viewing
      window.open(image.s3Url, '_blank');
    }
  }

  downloadImage(image: any) {
    if (image.s3Url) {
      // Create a temporary link to download the image
      const link = document.createElement('a');
      link.href = image.s3Url;
      link.download = image.documentName;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  getTotalDocumentCount(): number {
    const imageCount = this.tripMaterialForm.value.qcDocs?.length || 0;
    const videoCount = this.tripMaterialForm.value.videoDocs?.length || 0;
    return imageCount + videoCount;
  }

  getDocumentType(document: any): string {
    const fileName = document.documentName?.toLowerCase() || '';
    const videoExtensions = [
      '.mp4', '.mov', '.avi', '.mkv', '.webm', 
      '.m4v', '.3gp', '.wmv', '.flv', '.f4v', '.ogv'
    ];
    if (videoExtensions.some(ext => fileName.includes(ext))) {
      return 'video';
    }
    return 'image';
  }

  deleteImage(index: number) {
      this.tripMaterialForm.value.qcDocs.splice(index, 1);
      // Trigger change detection
      this.tripMaterialForm.patchValue({
        qcDocs: [...this.tripMaterialForm.value.qcDocs]
      });
  }

  deleteVideo(index: number) {
      this.tripMaterialForm.value.videoDocs.splice(index, 1);
      // Trigger change detection
      this.tripMaterialForm.patchValue({
        videoDocs: [...this.tripMaterialForm.value.videoDocs]
      });
  }

  // OTP Verification Methods
  get hasTransporterContact(): boolean {
    const mobile = this.tripData?.tspContactMobile;
    return mobile != null && String(mobile).trim() !== '';
  }

  get otpSharedByText(): string {
    const name = this.tripData?.driverName;
    const mobile = this.tripData?.mobileNumber;
    if (name && mobile) {
      return `${name} (${mobile})`;
    }
    if (name) {
      return name;
    }
    if (mobile) {
      return `(${mobile})`;
    }
    return 'the driver';
  }

  openOTPModal(unloadingDetails: any) {
    this.pendingUnloadingDetails = unloadingDetails;
    this.showOTPModal = true;
    this.otpInput = '';
    this.otpBoxes = ['', '', '', '', '', ''];
    this.otpError = '';
    this.resendOtpFlag = false;
    this.canResendOTP = false;
    this.remainingTime = '';
    this.isProcessingOTPInput = false;
  }

  closeOTPModal() {
    this.showOTPModal = false;
    this.pendingUnloadingDetails = null;
    this.otpInput = '';
    this.otpBoxes = ['', '', '', '', '', ''];
    this.otpError = '';
    this.isProcessingOTPInput = false;
    
    // Clear the timer when closing modal
    if (this.otpInterval) {
      clearInterval(this.otpInterval);
      this.otpInterval = null;
    }
    this.remainingTime = '';
    this.canResendOTP = false;
  }

  closeChangePopup() {
    this.showNoChangePopup = false;
  }

  onOTPInput(event: any) {
    // Allow only numbers
    this.otpInput = event.target.value.replace(/[^0-9]/g, '');
    this.otpError = '';
  }

  // Allow only numeric input for shortage/breakage/other charges fields
  onNumericInput(event: any, controlName?: string, index?: number) {
    const input = event.target;
    const originalValue = input.value;
    // Remove any non-numeric characters
    const numericValue = originalValue.replace(/[^0-9]/g, '');
    
    // Only update if the value changed (to avoid infinite loops)
    if (originalValue !== numericValue) {
      input.value = numericValue;
      
      // Update the form control directly if control name is provided
      if (controlName) {
        if (index !== undefined) {
          // For FormArray controls (like materialDispatchInfo)
          const materialArray = this.tripMaterialForm.get('materialDispatchInfo');
          if (materialArray) {
            const control = materialArray.at(index)?.get(controlName);
            if (control) {
              control.setValue(numericValue);
            }
          }
        } else {
          // For regular form controls
          const control = this.tripMaterialForm.get(controlName);
          if (control) {
            control.setValue(numericValue);
          }
        }
      }
    }
  }


  verifyOTP() {
    if (!this.otpInput || this.otpInput.length !== 6) {
      this.otpError = 'Please enter a valid 6-digit OTP';
      return;
    }

    this.isOTPVerifying = true;
    this.otpError = '';

    // Prepare payload for OTP verification - only OTP is needed
    const payload = {
      otp: this.otpInput
    };

    console.log('OTP Verification Payload:', payload);

    // Call OTP verification API - this is just for OTP verification
    let verifyObservable: Observable<any>;
    verifyObservable = this.destinationReceiverService.verifyObservation(this.userId, payload);

    verifyObservable.subscribe(
      (data: any) => {
        console.log('OTP Verification Success:', data);
        this.isOTPVerifying = true;
        
        this.closeOTPModal();
        this.submittedData = true;
        // After successful OTP verification, proceed with actual submission
        // this.processUnloadingDetailsAfterOTP();
      },
      (error: any) => {
        console.error('OTP Verification Error:', error);
        this.isOTPVerifying = false;
        this.otpError = error.error?.message || 'OTP verification failed. Please try again.';
      }
    );
  }

  resendOTP() {
    this.resendOtpFlag = true;
    this.otpInput = '';
    this.otpBoxes = ['', '', '', '', '', ''];
    this.otpError = '';
    this.canResendOTP = false;
    this.isProcessingOTPInput = false;
    
    // Clear all input fields
    setTimeout(() => {
      const inputs = document.querySelectorAll('.otp-box') as NodeListOf<HTMLInputElement>;
      inputs.forEach(input => {
        input.value = '';
      });
    }, 0);
    
    this.callVerifyObservationAPI(this.pendingUnloadingDetails);
  }

  startOTPTimer() {
    // Clear any existing interval
    if (this.otpInterval) {
      clearInterval(this.otpInterval);
    }
    
    let startTimer = 60; // 60 seconds countdown
    this.canResendOTP = false;
    
    this.otpInterval = setInterval(() => {
      const minutes = Math.floor(startTimer / 60);
      const seconds = startTimer % 60;
      this.remainingTime = `${("" + minutes).padStart(2, '0')}:${("" + seconds).padStart(2, '0')}`;
      startTimer--;
      
      if (startTimer < 0) {
        clearInterval(this.otpInterval);
        this.otpInterval = null;
        this.canResendOTP = true;
        this.remainingTime = '';
      }
    }, 1000);
  }

  // Override submitDetails to check for OTP verification
  submitDetails() {

    // Check if OTP verification is enabled - show OTP flow before submission
    if (this.isOTPVerificationEnabled && this.otpVerificationStatus == 'VERIFIED') {
      console.log('OTP Flow: Opening OTP modal for verification before submission');
      // Show OTP modal for verification - don't submit yet
      const unloadingDetails = this.prepareUnloadingDetails();
      
      // Call verifyObservation API first to send OTP to driver's mobile
      this.callVerifyObservationAPI(unloadingDetails);
      return;
    }

    console.log('Normal Flow: Proceeding with regular submission');
    // Normal flow - proceed with regular submission
    this.processUnloadingDetails();
  }

  // Extract unloading details preparation logic
  private prepareUnloadingDetails(): any {
    let materials: any = [];    
    const materialsFormData = this.tripMaterialForm.get('materialDispatchInfo') as FormArray;
    materialsFormData.value.forEach((material: any) => {
      let materialData: any = {
        materialId: material.id,
        material: material.material,
        quantity: material.quantity,
        shippingUnit: material.shippingUnit,
      };
      if (material.sku) {
        materialData.sku = material.sku;
      }
      if (material.breakageQuantity) {
        materialData.breakageQuantity = material.breakageQuantity;
      }
      if (material.leakageQuantity) {
        materialData.leakageQuantity = material.leakageQuantity;
      }
      if (material.shortageQuantity) {
        materialData.shortageQuantity = material.shortageQuantity;
      }
      materials.push(materialData);
    });
    
    let convertedTimeUnloaded = this.convertDateTime(this.tripMaterialForm.value.unloadingDate, this.tripMaterialForm.value.unloadingTime);
    let convertedTimeReported = this.convertDateTime(this.tripMaterialForm.value.destReportedDate, this.tripMaterialForm.value.destReportedTime);
    
    let unloadingDetails = {
      destReportedTime: convertedTimeReported,
      unloadingTime: convertedTimeUnloaded,
      materialDetails: materials,
      repackagingCharges: this.tripMaterialForm.value.repackagingCharges,
      remarks: this.tripMaterialForm.value.remarks,
    };
    
    if (this.tripMaterialForm.value.reporterDetails) {
      unloadingDetails['reporterDetails'] = this.tripMaterialForm.value.reporterDetails;
    }
    
    // Combine images and videos into observationDocuments
    let allDocuments = [];
    
    if (this.tripMaterialForm.value.qcDocs && this.tripMaterialForm.value.qcDocs.length > 0) {
      const cleanImageDocs = this.tripMaterialForm.value.qcDocs.map((doc: any) => ({
        documentId: doc.documentId,
        documentKey: doc.documentKey,
        documentName: doc.documentName
      }));
      allDocuments = allDocuments.concat(cleanImageDocs);
    }
    
    if (this.tripMaterialForm.value.videoDocs && this.tripMaterialForm.value.videoDocs.length > 0) {
      const cleanVideoDocs = this.tripMaterialForm.value.videoDocs.map((doc: any) => ({
        documentId: doc.documentId,
        documentKey: doc.documentKey,
        documentName: doc.documentName
      }));
      allDocuments = allDocuments.concat(cleanVideoDocs);
    }
    
    if (allDocuments.length > 0) {
      unloadingDetails['observationDocuments'] = allDocuments;
    }

    return unloadingDetails;
  }

  // Process unloading details (original submitDetails logic)
  private processUnloadingDetails() {
    const unloadingDetails = this.prepareUnloadingDetails();

    let unloadingDetailsObservable: Observable<any>;
    if (this.formType == 'DROP_TYPE') {
      unloadingDetailsObservable = this.reporterService.addUnloadingDetails(this.userId, unloadingDetails);
    } else if (this.formType == 'DESTINATION_TYPE') {
      unloadingDetailsObservable = this.destinationReceiverService.addUnloadingDetails(this.userId, unloadingDetails);
    }

    unloadingDetailsObservable.subscribe(
      (data: any) => {
        this.submittedData = true;
      },
      (error: any) => { }
    );
  }

  // Call verifyObservation API to send OTP before opening modal
  private callVerifyObservationAPI(unloadingDetails: any) {
    
    let verifyObservable: Observable<any>;
    verifyObservable = this.destinationReceiverService.sendOTPForVerification(this.userId, unloadingDetails);

    verifyObservable.subscribe(
      (response: any) => {
        console.log('verifyObservation API success:', response);
        this.hasUnverifiedObservations = true;
        this.resendOtpFlag = false; // Reset resend flag on success
        
        // Show success message that OTP has been sent
        const message = 'OTP has been resent to driver\'s mobile number';
        this._snackBar.open(message, 'X', {
          duration: 5000
        });
        
        // Start the OTP timer
        this.startOTPTimer();
        
        // Now open the OTP modal for verification
        this.openOTPModal(unloadingDetails);
      },
      (error: any) => {
        console.error('verifyObservation API error:', error);
        this.resendOtpFlag = false; // Reset resend flag on error
        
        // Show error message
        this._snackBar.open(error.error?.error || error.error, 'X', {
          duration: 5000
        });
      }
    );
  }

  // Process unloading details after successful OTP verification

  // Check if current time is within business hours (9 AM to 7 PM)
  private checkBusinessHours(): void {
    const now = new Date();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    
    // Business hours: 9:00 AM to 7:00 PM (19:00)
    const businessStartHour = 9;
    const businessEndHour = 19;
    
    // Convert current time to minutes for easier comparison
    const currentTimeInMinutes = currentHour * 60 + currentMinute;
    const businessStartInMinutes = businessStartHour * 60;
    const businessEndInMinutes = businessEndHour * 60;
    
    this.isWithinBusinessHours = currentTimeInMinutes >= businessStartInMinutes && 
                                 currentTimeInMinutes < businessEndInMinutes;
  }
  
  // Get business hours status message
  getBusinessHoursStatus(): string {
    if (this.isWithinBusinessHours) {
      return 'Phone support available now';
    } else {
      return 'Phone support closed - Available 9 AM - 7 PM';
    }
  }

  ngOnDestroy(): void {
    if (this.otpInterval) {
      clearInterval(this.otpInterval);
    }
  }

  // Historic Report Modal methods
  openHistoricReportModal(): void {
    this.showHistoricReportModal = true;
    this.historicReportForm.reset();
    this.dateRangeError = '';
  }

  closeHistoricReportModal(): void {
    if (this.isDownloadingReport) {
      // Don't allow closing while downloading
      return;
    }
    this.showHistoricReportModal = false;
    this.historicReportForm.reset();
    this.dateRangeError = '';
    this.isDownloadingReport = false;
    this.downloadProgress = '';
  }

  // Helper method to ensure date is a Date object
  private ensureDate(date: any): Date | null {
    if (!date) return null;
    if (date instanceof Date) return date;
    // Handle Moment objects (from Angular Material datepicker)
    if (date && typeof date === 'object' && date._isAMomentObject && typeof date.toDate === 'function') {
      return date.toDate();
    }
    // Handle Moment objects by checking for _d property (the underlying Date)
    if (date && typeof date === 'object' && date._d instanceof Date) {
      return date._d;
    }
    if (typeof date === 'string' || typeof date === 'number') {
      return new Date(date);
    }
    return null;
  }

  validateDateRange(): boolean {
    const startDateValue = this.historicReportForm?.get('startDate')?.value;
    const endDateValue = this.historicReportForm?.get('endDate')?.value;
    // Check if dates exist
    if (!startDateValue || !endDateValue) {
      this.dateRangeError = 'Please select both start and end dates';
      return false;
    }
    
    const start = this.ensureDate(startDateValue);
    const end = this.ensureDate(endDateValue);
    
    // Double check after conversion
    if (!start || !end) {
      this.dateRangeError = 'Please select both start and end dates';
      return false;
    }

    if (start > end) {
      this.dateRangeError = 'Start date cannot be greater than end date';
      return false;
    }

    const diffTime = Math.abs(end.getTime() - start.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays > 92) {
      this.dateRangeError = `Date range cannot exceed 92 days. Selected range: ${diffDays} days`;
      return false;
    }

    // If we get here, validation passed - clear error
    this.dateRangeError = '';
    return true;
  }

  getMaxEndDate(): Date | null {
    const startDateValue = this.historicReportForm.get('startDate')?.value;
    const startDate = this.ensureDate(startDateValue);
    if (!startDate) {
      return this.currentDate;
    }
    const maxDate = new Date(startDate);
    maxDate.setDate(maxDate.getDate() + 92);
    // Return the earlier of (start date + 92 days) or current date
    return maxDate > this.currentDate ? this.currentDate : maxDate;
  }

  onStartDateChange(event: MatDatepickerInputEvent<Date>): void {
    // formControlName automatically captures the value, just validate
    // Use setTimeout to ensure form value is updated after Angular's change detection
    setTimeout(() => {
      if (!event.value) {
        this.dateRangeError = '';
        this.historicReportForm.get('endDate')?.setValue(null);
        return;
      }
      
      // Reset end date if it's now invalid (more than 92 days from new start date)
      const endDateValue = this.historicReportForm.get('endDate')?.value;
      if (endDateValue) {
        const endDate = this.ensureDate(endDateValue);
        const maxEndDate = this.getMaxEndDate();
        if (maxEndDate && endDate && endDate > maxEndDate) {
          this.historicReportForm.get('endDate')?.setValue(null);
          this.dateRangeError = '';
        } else {
          // Validate - this will set or clear error appropriately
          this.validateDateRange();
        }
      } else {
        this.dateRangeError = '';
      }
    }, 0);
  }

  onEndDateChange(event: MatDatepickerInputEvent<Date>): void {
    // formControlName automatically captures the value, just validate
    // Use setTimeout to ensure form value is updated after Angular's change detection
    setTimeout(() => {
      if (!event.value) {
        this.dateRangeError = '';
        return;
      }
      
      const startDateValue = this.historicReportForm.get('startDate')?.value;
      if (startDateValue) {
        // Validate - this will set or clear error appropriately
        this.validateDateRange();
      } else {
        this.dateRangeError = '';
      }
    }, 0);
  }

  canDownloadReport(): boolean {
    // Don't allow download if already downloading
    if (this.isDownloadingReport) {
      return false;
    }
    
    const startDateValue = this.historicReportForm.get('startDate')?.value;
    const endDateValue = this.historicReportForm.get('endDate')?.value;
    
    // Check if both dates are selected
    if (!startDateValue || !endDateValue) {
      return false;
    }
    
    // Ensure dates are Date objects
    const startDate = this.ensureDate(startDateValue);
    const endDate = this.ensureDate(endDateValue);
    
    if (!startDate || !endDate) {
      return false;
    }
    
    // Check if there's a validation error
    if (this.dateRangeError && this.dateRangeError.trim().length > 0) {
      return false;
    }
    
    // Quick validation checks
    if (startDate > endDate) {
      return false;
    }
    
    const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays > 92) {
      return false;
    }
    
    // If we get here, everything is valid
    return true;
  }

  downloadHistoricReport(): void {
    if (!this.validateDateRange()) {
      return;
    }

    // Get dates from form
    const startDateValue = this.historicReportForm.get('startDate')?.value;
    const endDateValue = this.historicReportForm.get('endDate')?.value;
    
    // Ensure dates are Date objects
    const startDate = this.ensureDate(startDateValue);
    const endDate = this.ensureDate(endDateValue);

    if (!startDate || !endDate) {
      this._snackBar.open('Please select valid dates', 'Close', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        panelClass: ['error-snackbar']
      });
      return;
    }

    // Get GSTIN and warehouseCode from tripData
    const gstin = this.tripData?.orgId; // Fallback to example GSTIN
    const warehouseCode = this.tripData?.warehouseCode || this.tripData?.warehouse?.code || this.tripData?.dropPoint?.warehouseCode;
    
    if (!warehouseCode) {
      this._snackBar.open('Warehouse code not found', 'Close', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        panelClass: ['error-snackbar']
      });
      return;
    }

    this.isDownloadingReport = true;
    this.downloadProgress = 'Fetching data...';

    // Convert dates to timestamps in milliseconds
    const fromDate = startDate.getTime();
    const toDate = endDate.getTime();

    // Fetch all data with pagination
    this.fetchAllHistoricReportData(gstin, warehouseCode, fromDate, toDate);
  }

  fetchAllHistoricReportData(gstin: string, warehouseCode: string, fromDate: number, toDate: number): void {
    const allData: any[] = [];
    let pageIndex = 1;
    const pageSize = 100;
    let hasMoreData = true;

    const fetchPage = (): void => {
      if (!hasMoreData) {
        // All data fetched, export to Excel
        this.exportToExcel(allData);
        return;
      }

      this.downloadProgress = `Fetching page ${pageIndex}...`;

      const url = `${environment.conciergeUrl}/concierge/api/v1/mfg/${gstin}/historic-epod-report/_search`;
      
      const requestBody = {
        pageIndex: pageIndex,
        pageSize: pageSize,
        recipientId: this.userId,
        sortOrder: 'DESC',
        sortPath: 'createdOn',
        filters: {
          fromDate: [fromDate],
          toDate: [toDate],
          warehouseCode: [warehouseCode]
        }
      };

      this.http.post(url, requestBody).subscribe({
        next: (response: any) => {
          // Handle response structure: { totalResults: number, rows: [...] }
          const currentPageData = response?.rows || response?.data || [];
          
          if (currentPageData && Array.isArray(currentPageData) && currentPageData.length > 0) {
            allData.push(...currentPageData);
            
            // Check if there's more data
            const totalRecords = response.totalResults || response.totalRecords || response.total || response.totalElements || 0;
            const fetchedRecords = allData.length;
            
            // If current page has less data than pageSize, we've reached the end
            if (currentPageData.length < pageSize) {
              hasMoreData = false;
            } else if (totalRecords > 0 && fetchedRecords >= totalRecords) {
              hasMoreData = false;
            } else {
              // Continue to next page
              pageIndex++;
            }
            
            // Continue fetching next page or export
            fetchPage();
          } else {
            // No more data or unexpected response
            hasMoreData = false;
            if (allData.length === 0) {
              this.isDownloadingReport = false;
              this.downloadProgress = '';
              this._snackBar.open('No data found for the selected date range', 'Close', {
                duration: 3000,
                horizontalPosition: 'center',
                verticalPosition: 'bottom'
              });
            } else {
              this.exportToExcel(allData);
            }
          }
        },
        error: (error) => {
          console.error('Error fetching historic report:', error);
          this.isDownloadingReport = false;
          this.downloadProgress = '';
          this._snackBar.open('Error fetching historic report. Please try again.', 'Close', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            panelClass: ['error-snackbar']
          });
        }
      });
    };

    // Start fetching
    fetchPage();
  }

  exportToExcel(data: any[]): void {
    if (!data || data.length === 0) {
      this.isDownloadingReport = false;
      this.downloadProgress = '';
      this._snackBar.open('No data to export', 'Close', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom'
      });
      return;
    }

    this.downloadProgress = 'Generating Excel file...';

    try {
      // Helper function to format timestamp to readable date
      const formatDate = (timestamp: number | null | undefined): string => {
        if (!timestamp || typeof timestamp !== 'number') return '';
        // Check if it's a timestamp in milliseconds
        if (timestamp > 1000000000000) {
          const date = new Date(timestamp);
          // Format as DD/MM/YYYY HH:MM:SS
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const year = date.getFullYear();
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');
          return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
        }
        return String(timestamp);
      };

      // Map data to formatted Excel format with exact column order as specified
      const formattedData = data.map(item => {
        return {
          'LR Date': formatDate(item.lrDate),
          'Transporter name': item.transporterName || '-',
          'Reported Date': formatDate(item.reportedDate),
          'Unloaded Date': formatDate(item.unloadedDate),
          'Truck number': item.truckNumber || '-',
          'LR  Number': item.lrNumber || '-',
          'Origin Warehouse': item.originWarehouse || '-',
          'Destination Warehouse': item.destinationWarehouse || '-',
          'Invoice number': item.invoiceNumber || item.invoiceNo || item.invoice || '-',
          'Product name': item.productName || '-',
          'Qty Received': item.qtyReceived || 0,
          'Shortages': item.shortages || 0,
          'Damages': item.breakageQty || item.damages || 0,
          'POD Remarks': item.podRemarks || '-',
          'Received Date': formatDate(item.receivedDate),
          'Receiver Contact number': item.receiverContactNumber || '-',
          'Receiver Name': item.receiverName || item.receiver || '-',
          'Org Name': item.orgName || '-'
        };
      });

      // Create workbook and worksheet
      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Historic Report');

      // Set column widths for better readability
      const columnWidths = [
        { wch: 20 }, // LR Date
        { wch: 30 }, // Transporter name
        { wch: 20 }, // Reported Date
        { wch: 20 }, // Unloaded Date
        { wch: 15 }, // Truck number
        { wch: 15 }, // LR  Number
        { wch: 25 }, // Origin Warehouse
        { wch: 25 }, // Destination Warehouse
        { wch: 18 }, // Invoice number
        { wch: 40 }, // Product name
        { wch: 12 }, // Qty Received
        { wch: 12 }, // Shortages
        { wch: 12 }, // Damages
        { wch: 50 }, // POD Remarks
        { wch: 20 }, // Received Date
        { wch: 20 }, // Receiver Contact number
        { wch: 25 }, // Receiver Name
        { wch: 30 }  // Org Name
      ];
      worksheet['!cols'] = columnWidths;

      // Generate filename with date range
      const startDateValue = this.historicReportForm.get('startDate')?.value;
      const endDateValue = this.historicReportForm.get('endDate')?.value;
      const startDate = this.ensureDate(startDateValue);
      const endDate = this.ensureDate(endDateValue);
      const startDateStr = startDate?.toISOString().split('T')[0] || 'start';
      const endDateStr = endDate?.toISOString().split('T')[0] || 'end';
      const filename = `Historic_EPOD_Report_${startDateStr}_to_${endDateStr}.xlsx`;

      // Write file
      XLSX.writeFile(workbook, filename);

      this.isDownloadingReport = false;
      this.downloadProgress = '';
      this.closeHistoricReportModal();
      
      this._snackBar.open(`Report exported successfully! ${data.length} records.`, 'Close', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        panelClass: ['success-snackbar']
      });
    } catch (error) {
      console.error('Error exporting to Excel:', error);
      this.isDownloadingReport = false;
      this.downloadProgress = '';
      this._snackBar.open('Error exporting to Excel. Please try again.', 'Close', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        panelClass: ['error-snackbar']
      });
    }
  }
}

